import React from 'react';
import { Paper, Box, Divider, Stack, Typography } from '@mui/material';
import { monoFont } from '../../theme';

/**
 * Variante de KpiCard para indicadores con varias ventanas de tiempo
 * (por ejemplo altas de clientes: hoy / semana / mes).
 *
 * Mismo tratamiento sobrio que KpiCard: chip de 36px, sin acentos extra, y
 * `iconBg`/`iconColor` con tokens de la paleta.
 *
 * @param {Array<{label: string, value: any}>} stats Columnas a mostrar.
 */
const KpiMultiCard = ({ icon, iconBg, iconColor, label, stats = [], onClick, sx }) => (
	<Paper
		onClick={onClick}
		sx={{
			padding: '17px 18px',
			height: '100%',
			cursor: onClick ? 'pointer' : 'default',
			transition: 'border-color .18s ease',
			'&:hover': onClick ? { borderColor: 'text.disabled' } : undefined,
			...sx
		}}
	>
		<Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '16px' }}>
			<Box
				sx={{
					width: 36,
					height: 36,
					borderRadius: '10px',
					backgroundColor: iconBg,
					color: iconColor,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					fontSize: 20,
					flexShrink: 0
				}}
			>
				{icon}
			</Box>
			<Typography sx={{ fontSize: 12.5, fontWeight: 500, color: 'text.secondary' }}>
				{label}
			</Typography>
		</Box>

		<Stack direction="row" divider={<Divider orientation="vertical" flexItem />} spacing={2}>
			{stats.map((s) => (
				<Box key={s.label} sx={{ flex: 1, textAlign: 'center', minWidth: 0 }}>
					<Typography
						sx={{
							fontFamily: monoFont,
							fontSize: 22,
							fontWeight: 600,
							color: 'text.primary',
							lineHeight: 1.1
						}}
					>
						{s.value}
					</Typography>
					<Typography sx={{ fontSize: 11.5, color: 'text.secondary', marginTop: '2px' }}>
						{s.label}
					</Typography>
				</Box>
			))}
		</Stack>
	</Paper>
);

export default KpiMultiCard;
